define([
    "angular",
    "./tripOperationHistoryModule"
], function (angular, tripOperationHistoryModule) {
    "use strict";
    tripOperationHistoryModule.provider("tripOperationHistoryServiceUrl", [function () {

        var tripOperationHistoryUrlForNodeIdentifier;

        this.$get = [function () {
            return {
                getTripOperationHistoryUrlForNodeIdentifier: getTripOperationHistoryUrlForNodeIdentifier
            };
        }];

        function getTripOperationHistoryUrlForNodeIdentifier() {
            return tripOperationHistoryUrlForNodeIdentifier;
        }

        this.configure = function (server) {
            tripOperationHistoryUrlForNodeIdentifier = server.tripOperationHistoryUrlForNodeIdentifier;
        };
    }]);
});